import * as React from "react";
import type { SVGProps } from "react";
const SvgLockIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="lock_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M341.333 341.333V384h341.334v-42.667a170.667 170.667 0 0 0-341.334 0zM256 384v-42.667a256 256 0 1 1 512 0V384h42.667a128 128 0 0 1 128 128v298.667a128 128 0 0 1-128 128H213.333a128 128 0 0 1-128-128V512a128 128 0 0 1 128-128H256zm-42.667 85.333A42.667 42.667 0 0 0 170.667 512v298.667a42.667 42.667 0 0 0 42.666 42.666h597.334a42.667 42.667 0 0 0 42.666-42.666V512a42.667 42.667 0 0 0-42.666-42.667H213.333zm341.334 197.035v58.965a42.667 42.667 0 1 1-85.334 0v-58.965a64 64 0 1 1 85.334 0z"
    />
  </svg>
);
export default SvgLockIcon;
